import styled from 'styled-components'


const WarningStyle = styled.div`
margin: 30px 0 20px;
padding: 2rem 1rem 0.6rem;
border: 1px solid #c9c8c8;
border-radius: 6px;
text-align: center;
.box-bottom{
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    border: 0;
    height: 52px;
    width: 52px;
    margin: 1.2rem auto;
    padding: 0;
}
.box-bottom:before {
    content: url("data:image/svg+xml,%3Csvg width='52' height='52' viewBox='0 0 56 56' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M28.651 3.89549C28.2332 3.72804 27.7668 3.72804 27.349 3.89549L6.461 12.25L14.875 15.6135L36.414 6.99999L28.651 3.89549ZM41.125 8.88649L19.586 17.5L28 20.8635L49.539 12.25L41.125 8.88649ZM52.5 14.8365L29.75 23.9365V51.6635L52.5 42.5635V14.84V14.8365ZM26.25 51.667V23.933L3.5 14.8365V42.567L26.25 51.667ZM26.0505 0.643993C27.302 0.14349 28.698 0.14349 29.9495 0.643993L54.901 10.626C55.2254 10.756 55.5035 10.9802 55.6993 11.2696C55.8952 11.559 55.9999 11.9005 56 12.25V42.567C55.9996 43.2664 55.7896 43.9496 55.3972 44.5285C55.0048 45.1074 54.448 45.5555 53.7985 45.815L28.651 55.874C28.2332 56.0414 27.7668 56.0414 27.349 55.874L2.205 45.815C1.55488 45.5561 0.997298 45.1082 0.604247 44.5292C0.211196 43.9503 0.000722152 43.2668 0 42.567L0 12.25C8.13398e-05 11.9005 0.104803 11.559 0.300675 11.2696C0.496546 10.9802 0.774594 10.756 1.099 10.626L26.0505 0.643993Z' fill='black'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: 50%;
    border: 0;
    height: 52px;
    width: 52px;
    margin: 0;
    padding: 0;
}

`;

export const WarningBlock = () => {
    return (
        <WarningStyle> 
            <p>No encontramos tu pedido</p> 
            <p><strong>Puedes volver a ingresar tu número de boleta o factura</strong></p>
            <div className='box-bottom'></div>
        </WarningStyle>
    )
}